<template>
  <v-container class="admin-settings-hkiarace-banner" fluid>
    <v-row class="flex-grow-0">
      <v-col>
        <v-btn color="primary"
               @click="addBanner">
          {{ $t('admin_banner.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col>
        <HkiaraceBannerList full-height
                            :refresh-trigger.sync="refreshTrigger"></HkiaraceBannerList>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import HkiaraceBannerList from "@/components/hkiaraceBanner/HkiaraceBannerList";
import {ref} from "@vue/composition-api/dist/vue-composition-api";
import AddHkiaraceBannerModal from "@/components/hkiaraceBanner/AddHkiaraceBannerModal";

export default {
  name: 'HkiaraceBanner',
  components: {HkiaraceBannerList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const addBanner = async function () {
      const needRefresh = await root.$dialog.showAndWait(AddHkiaraceBannerModal, {
        showClose: false,
        persistent: true,
        scrollable: true,
        width: '95vw',
        height: '90vh',
      });

      if (needRefresh) {
        refresh();
      }
    }

    return {
      refreshTrigger,
      refresh,

      addBanner,
    }
  },
}
</script>

<style lang="less">
.admin-settings-hkiarace-banner {
  height: 100%;
  min-height: 75vh;
  display: flex;
  flex-direction: column;
}
</style>
